import React from 'react';
import { Card, Button, InputGroup, FormControl } from 'react-bootstrap';
import MaterialTable from "material-table";

function UsersManagement() {
    const url = "/api";
    const token = localStorage.getItem('token');
    const [usersRows, setUsersRows] = React.useState([]);
    const [newUser, setNewUser] = React.useState({
        email: undefined,
        password: undefined
    })

    const usersColumns = [
        {
            title: "User Email",
            field: "user",
            align: 'center'
        },
        {
            title: "Last Log In",
            field: "lastLogin",
            align: 'center'
        },

    ];

    async function computeUsers() {
        let options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            }
        }
        let response = await fetch(url + '/users', options).catch(err => {
            console.log(err);
        });
        if (response.status !== 200) {
            console.log("Can't get the users information");
        }
        var dataReceived = await response.json();
        var rows = [];
        dataReceived.forEach(user => {
            const dateLast = new Date(user.lastLogin);
            const months = [
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '10',
                '11',
                '12'
            ];
            const days = [
                'Domingo',
                'Lunes',
                'Martes',
                'Miércoles',
                'Jueves',
                'Viernes',
                'Sábado'
            ];
            const monthName = months[dateLast.getMonth()];
            const dayName = days[dateLast.getDay()];
            const year = dateLast.getFullYear();
            const dayNum = dateLast.getDate();
            const hours = (0 + dateLast.getHours().toString()).slice(-2);
            const minutes = (0 + dateLast.getMinutes().toString()).slice(-2);
            const seconds = (0 + dateLast.getSeconds().toString()).slice(-2);
            const formattedFecha = `${dayName}, ${dayNum} ${monthName} ${year}`;
            const formattedHora = `${hours}:${minutes}:${seconds}`;

            var lastMessage = "";
            if (dayName !== undefined) {
                lastMessage = formattedFecha + ' a las ' + formattedHora;
                lastMessage = dateLast.getDate() + '/' + monthName + '/' + dateLast.getFullYear() + ' at  ' + formattedHora;
            }

            rows.push({
                id: user._id,
                user: user.email,
                lastLogin: lastMessage !== '' ? lastMessage : '---'
            });
        });
        return (rows);
    }

    async function createUser() {
        const toJson = {
            "email": newUser.email,
            "password": newUser.password
        }
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify(toJson)
        }

        let response = await fetch(url + '/registerUser', options).catch(err => {
            console.log(err);
        });
        if (response.status !== 200) {
            console.log("The user can't be registered");
        }
        var dataReceived = await response.json();
        console.log("User registered " + dataReceived.email);
        var rows = await computeUsers();
        await setUsersRows(rows);
    }

    async function deleteUser(id) {
        const toJson = {
            "idUser": id,
        }
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify(toJson)
        }

        let response = await fetch(url + '/deleteUser', options).catch(err => {
            console.log(err);
        });
        if (response.status !== 200) {
            console.log("The user can't be deleted");
        }
        var dataReceived = await response.json();
        console.log("User deleted " + dataReceived.email);
        var rows = await computeUsers();
        await setUsersRows(rows);
    }


    React.useEffect(() => {
        var timer = undefined;
        async function fetchData() {
            var rows = await computeUsers();
            await setUsersRows(rows);
            timer = setTimeout(() => {
                fetchData();
            }, 30000);
        }
        fetchData();
        return () => clearTimeout(timer);
    }
        , []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <h1>Users Management</h1>
            <br></br>
            <br></br>
            <hr></hr>
            <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-start', marginTop: '50px', marginBottom: '50px' }}>
                <Card className="mb-4 mr-4" style={{ overflowX: 'scroll', width: '500px' , borderRadius: '20px'}}>
                    <Card.Body>
                        <Card.Title><strong>New User</strong></Card.Title>
                        <br></br>
                        <br></br>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon1">Email</InputGroup.Text>
                            <FormControl placeholder="Introduce user's email..."
                                aria-label="user"
                                aria-describedby="basic-addon1"
                                onChange={(e) => setNewUser({ email: e.target.value, password: newUser.password })}
                                type="email"></FormControl>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text id="basic-addon1">Password</InputGroup.Text>
                            <FormControl
                                placeholder="Introduce user's password..."
                                aria-label="pwd"
                                onChange={(e) => setNewUser({ email: newUser.email, password: e.target.value })}
                                aria-describedby="basic-addon1"
                                type="password"
                            />
                        </InputGroup>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                            <Button variant="primary" id="button-addon2" style={{ backgroundColor: '#076129', borderColor: '#076129' }} onClick={createUser}>
                                Create
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
                <Card className="mb-4 mr-4" style={{ display: 'flex', width: '700px', overflowX: 'scroll' , borderRadius: '20px'}}>
                    <Card.Body>
                        <Card.Title><strong>Users</strong></Card.Title>
                        <br></br>
                        <MaterialTable
                            title="Users"
                            data={usersRows}
                            columns={usersColumns}
                            options={{ search: false, paging: false, padding: 'dense', headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                            style={{ textAlign: 'center' , borderRadius: '20px'}}
                            localization={
                                {
                                    header: {
                                        actions: ""
                                    }
                                }
                            }
                            actions={[
                                {
                                    icon: 'delete',
                                    tooltip: 'Delete User',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        deleteUser(rowData.id);
                                    }
                                }
                            ]}
                        />
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default UsersManagement;
